import { useEffect, useEffectEvent } from 'react';

import { useNavigate } from '#hooks/useNavigate';

import { tomarRutaAviso } from './avisosPush';

/**
 * Al pulsar un aviso, el service worker apunta qué pantalla abrir. Si la app
 * estaba cerrada, la carga del presupuesto pasa por la raíz y se pierde la
 * dirección: aquí se recupera en cuanto el presupuesto está abierto. Si ya
 * estaba abierta, el service worker manda un mensaje y se navega sin recargar.
 */
export function useIrDesdeAviso() {
  const navigate = useNavigate();
  // Fuera de las dependencias: `navigate` cambia con cada pantalla y el
  // efecto se rehacía a mitad de lectura, perdiendo la ruta ya tomada.
  const irA = useEffectEvent((ruta: string) => void navigate(ruta));

  useEffect(() => {
    let vivo = true;
    async function ir() {
      const ruta = await tomarRutaAviso();
      if (vivo && ruta) {
        irA(ruta);
      }
    }
    void ir();

    const sw = typeof navigator !== 'undefined' && navigator.serviceWorker;
    if (!sw) {
      return () => {
        vivo = false;
      };
    }
    const alMensaje = (e: MessageEvent) => {
      if (e.data?.tipo === 'rumbo-ir') {
        void ir();
      }
    };
    sw.addEventListener('message', alMensaje);
    return () => {
      vivo = false;
      sw.removeEventListener('message', alMensaje);
    };
  }, []);
}
